import { getRequestChangesStatus } from 'src/utils/escrow';
import { EscrowStatusEnum, EscrowPartyTypeEnum, InvitationStatusEnum } from 'src/graphql/schema';
import { OtherEscrowStatusEnum, OtherContinuityEscrowStatusEnum } from 'src/shared/constants';

import type { IClientChangesRequestedQuery } from 'src/graphql/actions/suggestChanges/clientChangesRequested.query';

type IGetActionBannerStatusParams = {
  escrowStatus: EscrowStatusEnum;
  currentCompanyRole: EscrowPartyTypeEnum | null | undefined;
  changesRequested: IClientChangesRequestedQuery | undefined;
  escrowTermination:
    | {
        requesterParty: EscrowPartyTypeEnum | null | undefined;
        policy: { accept: boolean; reject: boolean };
        terminateAt?: string;
      }
    | null
    | undefined;
  escrowInvitationStatus?: InvitationStatusEnum;
};

export const getActionBannerStatus = ({
  escrowStatus,
  currentCompanyRole,
  changesRequested,
  escrowTermination,
  escrowInvitationStatus,
}: IGetActionBannerStatusParams): EscrowStatusEnum | OtherEscrowStatusEnum | OtherContinuityEscrowStatusEnum => {
  let status: EscrowStatusEnum | OtherEscrowStatusEnum = escrowStatus;
  if (escrowInvitationStatus === InvitationStatusEnum.Rejected) status = OtherEscrowStatusEnum.Rejected;
  if (changesRequested?.clientChangesRequested.isRequested)
    status =
      getRequestChangesStatus(currentCompanyRole!, changesRequested.clientChangesRequested) ??
      OtherEscrowStatusEnum.ChangesRequestedSuggester;
  if (
    [EscrowStatusEnum.Onboarding, EscrowStatusEnum.Signed, EscrowStatusEnum.Active].includes(escrowStatus) &&
    escrowTermination
  ) {
    const canReview = escrowTermination.policy.accept || escrowTermination.policy.reject;

    if (currentCompanyRole === escrowTermination.requesterParty)
      status = OtherEscrowStatusEnum.TerminationRequestedSuggester;
    else if (canReview) status = OtherEscrowStatusEnum.TerminationRequestedReceiver;
    else status = OtherEscrowStatusEnum.TerminationRequestedReceiverViewer;
  }

  return status;
};
